/* eslint-disable react/no-danger */
import React, { useContext, useEffect } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import {
  arrayOf, params, shape, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';
import { Image, Heading } from '@thd-olt-component-react/core-ui';
import { Tile } from '@thd-olt-component-react/tile';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { StoreDetailsContext } from '../StoreDetails.context';
import styles from './store-recycle-program.module.scss';

const cx = classNames.bind(styles);

const StoreRecycleProgram = ({ className }) => {

  const { storeId } = useContext(StoreDetailsContext);
  const options = {
    variables: {
      storeId,
    }
  };
  const { data, loading, error } = useDataModel('seoStoreDetails', options);
  const recycleDetails = data?.seoStoreDetails?.[0];
  const content = recycleDetails?.content || {};

  if (loading) {
    return (
      <Tile shadow={false}>
        <LoadingPlaceholder
          color="#E0E0E0"
          rows={3}
          ready={false}
          style={{ height: '45px' }}
        >
          Loading...
        </LoadingPlaceholder>
        {[1, 2, 3].map((index) => {
          return (
            <LoadingPlaceholder
              color="#E0E0E0"
              rows={2}
              type="media"
              ready={false}
              key={index}
              style={{ height: '45px', margin: '25px' }}
            >
              Loading...
            </LoadingPlaceholder>
          );
        })}
      </Tile>
    );
  }
  if (!recycleDetails || error) return null;

  return (
    <div className={cx(className, 'recycle__container')}>
      <Tile>
        <Heading title={recycleDetails.header} underline />
        <div className={cx('recycle__subheader')}>{recycleDetails.subHeader}</div>
        <div className={cx('recycle__content-wrapper')}>
          {content.map(({ imageUrl, text }, index) => {
            return (
              <div key={index} className={cx('recycle__content')}>
                <Image
                  className={cx('recycle__content--image')}
                  lazy
                  width={44}
                  height={44}
                  src={imageUrl}
                  alt="eco_image"
                />
                <div className={cx('recycle__content--text')} dangerouslySetInnerHTML={{ __html: text }} />
              </div>
            );
          })}
        </div>
      </Tile>
    </div>
  );
};

StoreRecycleProgram.propTypes = {
  className: string
};

StoreRecycleProgram.defaultProps = {
  className: null
};

StoreRecycleProgram.displayName = 'StoreRecycleProgram';

StoreRecycleProgram.dataModel = {
  seoStoreDetails: params({ storeId: stringType().isRequired() }).arrayOf(shape({
    header: stringType(),
    subHeader: stringType(),
    content: arrayOf(shape({
      imageUrl: stringType(),
      text: stringType()
    }))
  }))
};

export { StoreRecycleProgram };
